<template>
    <div class="row">
        <div class="col-md-8 col-12" >
        <table class="table table-borderless">
            <thead style="border-bottom: 1px solid #ebedf2;">
                <tr>
                  <th style="font-weight: 600; color: #333; padding: 0 0 15px 0 !important;">Form</th>
                  <th style="font-weight: 600; color: #333; padding-bottom: 15px; text-align: center;">Status</th>
                  <th v-if="actionType" style="font-weight: 600; color: #333; padding-bottom: 15px; text-align: center;">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(taskForm, index) in taskForms" :key="index">
                  <td style="vertical-align: middle; padding: 15px 0 15px 0 !important;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 6px; color: #212529; line-height: 1.2;">{{ taskForm.form.name }}</div>
                    <div class="progress" v-html="progressHtmlRender(getRowProgress(taskForm))" style="height: 10px; border-radius: 10px; background-color: #f1f1f1; width: 95%;"></div>
                  </td>
                  <td style="vertical-align: middle; text-align: center; padding: 15px 10px;">
                    <div style="display: flex; align-items: center; justify-content: center; height: 100%;">
                        <span v-if="taskForm.response_status" 
                              :style="{ 
                                  color: (taskForm.response_status !== 'Not submitted' && taskForm.response_status !== 'not submitted') ? '#28a745' : '#6c757d', 
                                  fontWeight: (taskForm.response_status !== 'Not submitted' && taskForm.response_status !== 'not submitted') ? '600' : '400',
                                  fontSize: '14px',
                                  display: 'inline-block',
                                  lineHeight: '1'
                              }">
                            {{ taskForm.response_status }}
                        </span>
                    </div>
                  </td>
                  <td v-if="actionType" style="vertical-align: middle; text-align: center; padding: 15px 0;">
                    <div style="display: flex; align-items: center; justify-content: center; height: 100%;">
                        <a :href="updateTaskFormResponseUrl(task_id,taskForm.form_id, taskForm.form_body_id, taskForm.id)"
                           class="btn btn-sm btn-success" 
                           style="border-radius: 6px; padding: 8px 18px; font-weight: 500; box-shadow: 0 2px 5px rgba(40, 167, 69, 0.15); transition: all 0.2s;"
                           target="_blank">Save Your Response</a>
                    </div>
                  </td>
                </tr>
                <tr v-if="taskForms.length == 0">
                    <td colspan="3" class="text-center p-primary">No Forms Found</td>
                </tr>
            </tbody>
        </table>
        </div>
        <div class="col-md-4 col-12 form-progress">
            <app-widget
            class="mt-2"
            :type="'app-widget-with-circle'"
            label="Forms Progress"
            :number="calculatedOverallProgress"
            />
        </div>
    </div>
</template>

<script>

export default {
  name: "FormProgress",

  props: {
    taskForms: Array,
    formProgress: Object,
    task_id: Number,
    actionType: Boolean,
  },
  data() {
    return {
        totalPercentage: 0,
    };
  },

  methods: {
    getRowProgress(taskForm){
      try{
        const status = (taskForm?.response_status || '').toString().toLowerCase();
        if (status && status.includes('submitted') && !status.includes('not')) {
          return 100;
        }
        const val = this.formProgress ? this.formProgress[taskForm.id] : 0;
        if (val === undefined || val === null) return 0;
        const num = Number(val);
        return isNaN(num) ? 0 : num;
      }catch(e){
        return 0;
      }
    },
    progressHtmlRender(value) {
      const displayValue = value === undefined || value === null ? 0 : value;
      return `<div class="progress-bar progress-style" role="progressbar" style="width: ${displayValue}%; height: 10px; line-height: 10px; font-size: 9px; vertical-align: middle;" aria-valuenow="${displayValue}" aria-valuemin="0" aria-valuemax="100">${displayValue}</div>`;
    },
    updateTaskFormResponseUrl(taskId, form_id, form_body_id, form_revision_id) {
      return (
          '/taskFormResponse/save/' +
          form_body_id +
          '/?form_id=' +
         form_id +
          '&task_id=' +
          taskId +
          '&form_revision_id=' +
          form_revision_id +
          '&type=save_response&user_id=' +
          this.userId +'&new_tab=yes'
      );
    },
  },
  computed: {
    userId() {
      return this.$store.state.user.loggedInUser.id;
    },
    calculatedOverallProgress() {
      if (!this.taskForms || this.taskForms.length === 0) return 0;
      let total = 0;
      let count = 0;
      this.taskForms.forEach((taskForm) => {
        total += this.getRowProgress(taskForm);
        count++;
      });
      return count === 0 ? 0 : Math.round(total / count);
    },
  },
};
</script>
<style>
.progress-style {
  text-align: center !important;
  font-weight: bold !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #fff !important;
}

.form-progress .card.card-with-shadow {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
  border-radius: 15px !important;
  border: 1px solid #f0f0f0 !important;
  background: #fff;
  transition: transform 0.3s ease;
}

.form-progress .card.card-with-shadow:hover {
  transform: translateY(-5px);
}

.form-progress .circular-progress-bar .progress {
    width: 160px !important;
    height: 160px !important;
    line-height: 160px !important;
    background: none !important;
    margin: 20px auto !important;
    box-shadow: none !important;
    position: relative !important;
}

.form-progress .circular-progress-bar .progress:after {
    content: "" !important;
    width: 100% !important;
    height: 100% !important;
    border-radius: 50% !important;
    border: 12px solid #f8f9fa !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    box-shadow: inset 0 2px 4px rgba(0,0,0,0.05) !important;
}

.form-progress .circular-progress-bar .progress .progress-bar {
    border-width: 12px !important;
    border-color: #4e73df !important; /* Professional Blue */
    filter: drop-shadow(0 2px 4px rgba(78, 115, 223, 0.2));
}

.form-progress .circular-progress-bar .progress .progress-left .progress-bar {
    border-top-right-radius: 85px !important; /* Slightly larger to prevent gaps */
    border-bottom-right-radius: 85px !important;
}

.form-progress .circular-progress-bar .progress .progress-right .progress-bar {
    border-top-left-radius: 85px !important;
    border-bottom-left-radius: 85px !important;
}

.form-progress .circular-progress-bar .progress .progress-value {
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-direction: column !important;
}

.form-progress .circular-progress-bar .progress .progress-value h6 {
    font-size: 28px !important;
    font-weight: 700 !important;
    color: #4e73df !important;
    margin: 0 !important;
}

.form-progress .circular-progress-bar small {
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #4a5568 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    margin-top: 15px !important;
}
</style>
